if (!customElements.get('ls-faq-page')) {
  customElements.define(
    'ls-faq-page',
    class LsFaqPage extends HTMLElement {
      connectedCallback() {
        this.search = this.querySelector('[data-lsfp-search]');
        this.pills = Array.from(this.querySelectorAll('[data-lsfp-filter]'));
        this.categories = Array.from(this.querySelectorAll('[data-lsfp-cat]'));
        this.empty = this.querySelector('[data-lsfp-empty]');

        this.activeFilter = 'all';
        this.query = '';
        this.debounce = null;

        this.items = Array.from(this.querySelectorAll('.lsfaq__item')).map((el) => {
          const q = el.querySelector('.lsfaq__q-text');
          const a = el.querySelector('.lsfaq__a');
          const text = `${q ? q.textContent : ''} ${a ? a.textContent : ''}`
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .trim();
          return { el, text };
        });

        this.onPillClick = this.onPillClick.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.pills.forEach((pill) => pill.addEventListener('click', this.onPillClick));
        if (this.search) {
          this.search.addEventListener('input', this.onSearch);
          this.search.addEventListener('search', this.onSearch);
        }
      }

      disconnectedCallback() {
        this.pills.forEach((pill) => pill.removeEventListener('click', this.onPillClick));
        if (this.search) {
          this.search.removeEventListener('input', this.onSearch);
          this.search.removeEventListener('search', this.onSearch);
        }
        clearTimeout(this.debounce);
      }

      onPillClick(event) {
        const pill = event.currentTarget;
        this.activeFilter = pill.getAttribute('data-lsfp-filter') || 'all';

        this.pills.forEach((p) => {
          const active = p === pill;
          p.classList.toggle('is-active', active);
          p.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        this.apply();
      }

      onSearch() {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.query = (this.search.value || '').toLowerCase().replace(/\s+/g, ' ').trim();
          this.apply();
        }, 150);
      }

      apply() {
        let totalVisible = 0;

        this.items.forEach((item) => {
          const matchesQuery = this.query === '' || item.text.includes(this.query);
          item.matchesQuery = matchesQuery;
        });

        this.categories.forEach((cat) => {
          const matchesFilter =
            this.activeFilter === 'all' || cat.getAttribute('data-lsfp-cat') === this.activeFilter;

          let visibleInCat = 0;
          const catItems = cat.querySelectorAll('.lsfaq__item');
          catItems.forEach((el) => {
            const data = this.items.find((i) => i.el === el);
            const show = matchesFilter && (!data || data.matchesQuery);
            el.hidden = !show;
            if (show) visibleInCat += 1;
          });

          cat.hidden = !matchesFilter || visibleInCat === 0;
          totalVisible += visibleInCat;
        });

        if (this.empty) this.empty.hidden = totalVisible !== 0;
      }
    }
  );
}
